import {Component, OnDestroy, OnInit} from "@angular/core";
import {DocumentService} from "../../services/document.service";
import {DOCUMENT_TYPES, VALUE_TYPE} from "../../enums/enums";
import {CollectionService} from "../../services/collection.service";
import {BusService} from "../../services/bus.service";
import {paramsHelper} from "../../helpers/params-helper";
import {UI_TEXTS} from "../../enums/e-texts";
import * as _ from "underscore";
import {JP} from "../../helpers/jp";
import {FactoryService} from "../../services/factory.service";
import {IDocument} from "../../interfaces/document.definition";
import {E_ENDPOINTS} from "../../helpers/params/loader-params";
import {Subject} from "rxjs/Subject";


@Component({
    templateUrl: "./profile.attributes-page.component.html"
})


export class ProfileAttributesPageComponent implements OnInit, OnDestroy {
  UI_TEXTS = UI_TEXTS;
    VALUE_TYPE = VALUE_TYPE;
    E_ENDPOINTS = E_ENDPOINTS;
    documentType: string = DOCUMENT_TYPES.SETTINGS;
    documentId: string = null;
    document: IDocument;

    tabsConfig = [
      UI_TEXTS.ATTR_TAB_PROFILE,
      UI_TEXTS.ATTR_TAB_DAILIES,
      UI_TEXTS.ATTR_TAB_DAILY_BONUSES,
      UI_TEXTS.ATTR_TAB_ZEPPELIN,
      UI_TEXTS.ATTR_TAB_SHOP,
      UI_TEXTS.ATTR_TAB_CAMPING,
      UI_TEXTS.ATTR_TAB_NUTS
    ];

    private unsubscribe: Subject<void> = new Subject<void>();

    constructor(private collectionService:CollectionService,
                private factoryService: FactoryService,
                private busService: BusService,
                private documentService: DocumentService) {
      this.busService.onDocumentUpdated
        .takeUntil(this.unsubscribe)
        .subscribe(e => {this.document = e.document;});
      this.busService.onDocumentSaved
        .takeUntil(this.unsubscribe)
        .subscribe(e => this.loadDocument());
    }


    get nutConfig(): any { return this.document["nutConfig"]; }
    get cupRewardSettings(): any { return this.document["cupRewardSettings"]; }
    get zeppelinSettings(): any {
        if (typeof this.document["zeppelinSettings"] === "undefined"
                || this.document["zeppelinSettings"] === null) {
            this.document["zeppelinSettings"] = {};
        }
        return this.document["zeppelinSettings"];
    }

    get dailyBonuses(): any {
      if (!JP.has(this.document, "/dailyBonus")) {
        JP.set(this.document, "/dailyBonus", []);
      }

      if (!_.isArray(JP.get(this.document, "/dailyBonus"))) {
        JP.set(this.document, "/dailyBonus", []);
      }
      return JP.get(this.document, "/dailyBonus");
    }


    get locationSettings(): any{ return this.document["locationSettings"]; }
    get dailyQuestSettings(): any{ return this.document["dailyQuestSettings"]; }
    get marketSettings(): any{ return this.document["marketSettings"]; }
    get campingSettings(): any{
      if (typeof this.document["campingSettings"] === "undefined"
        || this.document["campingSettings"] === null) {
        this.document["campingSettings"] = {};
      }
      return this.document["campingSettings"];
    }


    addDayOptionToDailyBonuses() {
      this.factoryService.addDayOptionToDailyBonuses(this.dailyBonuses);
    }


    ngOnInit(): void {
      const params = paramsHelper.loader()
        .setEndpointApi()
        .setNavParams(0, 1)
        .setObjectType(this.documentType);

        this.collectionService.loadChunkAndAssertOne(params)
          .takeUntil(this.unsubscribe)
            .subscribe(document => {
                this.documentId = document._id;
                this.loadDocument();
            });
    }

    ngOnDestroy(): void {
      this.unsubscribe.next();
      this.unsubscribe.complete();
    }


    onLoadClick():void {
        this.loadDocument();
    }


    private loadDocument():void {
        this.documentService.load(E_ENDPOINTS.API, this.documentType, this.documentId);
    }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/attributes/profile.attributes-page.component.ts